/*
 * ===== assets/cart-drawer.js =====
 * AJAX 購物車抽屜控制器
 */

(function () {
  'use strict';

  var drawer = document.getElementById('bh-cart-drawer');
  if (!drawer) return;

  var closeBtn = document.getElementById('bh-cart-drawer-close');
  var itemsList = document.getElementById('bh-cart-drawer-items-list');
  var subtotalVal = document.getElementById('bh-cart-drawer-subtotal-val');
  var footer = drawer.querySelector('.bh-cart-drawer-footer');
  var recSection = document.getElementById('bh-cart-drawer-recommendations');
  var noteInput = drawer.querySelector('[data-cart-note-input]');
  var shippingWrap = drawer.querySelector('.bh-cart-drawer-shipping');
  var shippingBar = drawer.querySelector('[data-shipping-bar]');
  var shippingMsg = drawer.querySelector('[data-shipping-msg]');

  var activeLocale = document.documentElement.lang || 'zh-TW';

  // 靜態翻譯字典（Fallback）
  var translations = {
    'zh-TW': {
      empty: '您的購物車是空的。',
      congrats: '恭喜！您已符合免運費資格！',
      needed: '再購買 {{amount}} 即可享有免運費優惠！',
      explore: '探索商品',
      exploreUrl: '/collections/all'
    },
    'en': {
      empty: 'Your cart is empty.',
      congrats: 'You qualify for free shipping!',
      needed: 'You are {{amount}} away from free shipping.',
      explore: 'Shop Now',
      exploreUrl: '/collections/all'
    }
  };

  var t = translations[activeLocale] || translations['zh-TW'];

  /* ---------- Money Formatter ---------- */
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    // Fallback: 簡易台幣或美元格式化
    var num = (cents / 100).toFixed(0);
    return '$' + Number(num).toLocaleString();
  }

  /* ---------- Open / Close ---------- */
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    void drawer.offsetWidth;
    drawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-active');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-drawer-open');
    setTimeout(function () {
      drawer.setAttribute('aria-hidden', 'true');
    }, 400);
  }

  /* ---------- Rebuild HTML from Shopify Cart JSON ---------- */
  function updateDrawerHTML(cart) {
    // 1. 更新頁首購物車氣泡
    var badge = document.querySelector('.bh-cart-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    // 2. 更新小計
    if (subtotalVal) {
      subtotalVal.textContent = formatMoney(cart.total_price);
    }

    // 3. 隱藏/顯示 footer 與加購區
    if (cart.item_count > 0) {
      if (footer) footer.style.display = 'flex';
      if (recSection) recSection.style.display = 'block';
    } else {
      if (footer) footer.style.display = 'none';
      if (recSection) recSection.style.display = 'none';
    }

    // 4. 更新免運門檻進度條
    if (shippingWrap && shippingBar && shippingMsg) {
      var limit = parseInt(shippingWrap.getAttribute('data-free-shipping-limit'), 10);
      if (limit > 0) {
        var pct = (cart.total_price / limit) * 100;
        if (pct > 100) pct = 100;
        shippingBar.style.width = pct + '%';

        if (cart.total_price >= limit) {
          shippingMsg.textContent = t.congrats;
        } else {
          var remainingVal = limit - cart.total_price;
          var formattedRemaining = formatMoney(remainingVal);
          shippingMsg.textContent = t.needed.replace('{{amount}}', formattedRemaining);
        }
      }
    }

    // 5. 渲染商品清單
    if (itemsList) {
      if (cart.items.length === 0) {
        itemsList.innerHTML = '<div class="bh-cart-drawer-empty-state"><p>' + t.empty + '</p><a href="' + t.exploreUrl + '" class="bh-btn-primary" style="margin-top: 16px; display: inline-flex;">' + t.explore + '</a></div>';
        return;
      }

      var html = '';
      cart.items.forEach(function (item, index) {
        var imgHtml = item.image 
          ? '<img src="' + item.image + '" alt="' + item.product_title + '" width="80" height="80" loading="lazy">'
          : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="bh-placeholder"><rect width="100%" height="100%" fill="#1a1a1a"/></svg>';

        var metaHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="bh-cart-drawer-item-meta">' + item.variant_title + '</p>'
          : '';

        // 客製化屬性
        var propHtml = '';
        if (item.properties && Object.keys(item.properties).length > 0) {
          propHtml += '<div class="bh-cart-drawer-item-properties">';
          for (var propName in item.properties) {
            var val = item.properties[propName];
            if (val) {
              propHtml += '<p class="bh-cart-drawer-item-property"><strong>' + propName + '</strong>: ';
              if (val.indexOf('/uploads/') > -1) {
                propHtml += '<a href="' + val + '" target="_blank">' + val.substring(val.lastIndexOf('/') + 1) + '</a>';
              } else {
                propHtml += val;
              }
              propHtml += '</p>';
            }
          }
          propHtml += '</div>';
        }

        html += '<div class="bh-cart-drawer-item" data-cart-item-key="' + item.key + '" data-line-index="' + (index + 1) + '">';
        html += '  <div class="bh-cart-drawer-item-img">' + imgHtml + '</div>';
        html += '  <div class="bh-cart-drawer-item-details">';
        html += '    <a href="' + item.url + '" class="bh-cart-drawer-item-title">' + item.product_title + '</a>';
        html += metaHtml;
        html += propHtml;
        html += '    <div class="bh-cart-drawer-item-price-row">';
        html += '      <span class="bh-cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>';
        html += '    </div>';
        html += '    <div class="bh-cart-drawer-item-qty-actions">';
        html += '      <div class="bh-cart-drawer-qty-selector">';
        html += '        <button type="button" class="bh-cart-drawer-qty-btn minus" data-qty-change="-1" aria-label="減少數量">&minus;</button>';
        html += '        <input type="number" class="bh-cart-drawer-qty-input" value="' + item.quantity + '" min="0" aria-label="商品數量" data-item-qty>';
        html += '        <button type="button" class="bh-cart-drawer-qty-btn plus" data-qty-change="1" aria-label="增加數量">&plus;</button>';
        html += '      </div>';
        html += '      <button type="button" class="bh-cart-drawer-remove-btn" data-cart-remove-item aria-label="移除商品">';
        html += '        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
        html += '      </button>';
        html += '    </div>';
        html += '  </div>';
        html += '</div>';
      });

      itemsList.innerHTML = html;
    }
  }

  /* ---------- Fetch API Updates ---------- */
  function refreshCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateDrawerHTML(cart);
        updateCrossSellRecommendations(cart);
      });
  }

  function changeQuantity(key, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateDrawerHTML(cart);
      updateCrossSellRecommendations(cart);
    });
  }

  function addCrossSellItem(variantId, btn) {
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      btn.classList.remove('is-loading');
      refreshCart();
    })
    .catch(function () {
      btn.classList.remove('is-loading');
    });
  }

  /* ---------- Dynamic Cross-Sell Refresh ---------- */
  function updateCrossSellRecommendations(cart) {
    if (cart.items.length === 0) {
      if (recSection) recSection.style.display = 'none';
      return;
    }
    // 簡單過濾已在購物車中的商品
    var recCards = drawer.querySelectorAll('.bh-cart-drawer-rec-card');
    var shownCount = 0;
    recCards.forEach(function (card) {
      var variantId = parseInt(card.getAttribute('data-rec-product-id'), 10);
      var alreadyInCart = cart.items.some(function (item) {
        return item.variant_id === variantId;
      });

      if (alreadyInCart || shownCount >= 2) {
        card.style.display = 'none';
      } else {
        card.style.display = 'flex';
        shownCount++;
      }
    });

    if (recSection) {
      recSection.style.display = shownCount > 0 ? 'block' : 'none';
    }
  }

  /* ---------- Event Delegation ---------- */
  if (itemsList) {
    // 數量與刪除事件
    itemsList.addEventListener('click', function (e) {
      var btn = e.target.closest('.bh-cart-drawer-qty-btn');
      if (btn) {
        var input = btn.closest('.bh-cart-drawer-qty-selector').querySelector('.bh-cart-drawer-qty-input');
        var currentQty = parseInt(input.value, 10);
        var change = parseInt(btn.getAttribute('data-qty-change'), 10);
        var newQty = currentQty + change;
        if (newQty < 0) newQty = 0;
        
        var key = btn.closest('.bh-cart-drawer-item').getAttribute('data-cart-item-key');
        input.value = newQty;
        changeQuantity(key, newQty);
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove-item]');
      if (removeBtn) {
        var key = removeBtn.closest('.bh-cart-drawer-item').getAttribute('data-cart-item-key');
        changeQuantity(key, 0);
        return;
      }
    });

    // 數量手動輸入事件
    itemsList.addEventListener('change', function (e) {
      var input = e.target.closest('[data-item-qty]');
      if (input) {
        var newQty = parseInt(input.value, 10);
        if (isNaN(newQty) || newQty < 0) newQty = 1;
        var key = input.closest('.bh-cart-drawer-item').getAttribute('data-cart-item-key');
        changeQuantity(key, newQty);
      }
    });
  }

  // 交叉銷售加購按鈕事件
  if (recSection) {
    recSection.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-rec-add]');
      if (addBtn) {
        var variantId = addBtn.closest('.bh-cart-drawer-rec-card').getAttribute('data-rec-product-id');
        addCrossSellItem(parseInt(variantId, 10), addBtn);
      }
    });
  }

  // 訂單備註存檔事件 (失焦或輸入延遲)
  if (noteInput) {
    noteInput.addEventListener('change', function () {
      var noteText = noteInput.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ note: noteText })
      });
    });
  }

  // 全域加購事件監聽 (對接商品詳情頁與商品卡片 AJAX)
  document.addEventListener('cart:updated', function () {
    refreshCart();
    openDrawer();
  });

  // 頁首氣泡按鈕點擊打開購物車抽屜
  var headerCartBtn = document.getElementById('cart-icon-bubble');
  if (headerCartBtn) {
    headerCartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart();
      openDrawer();
    });
  }

  // 關閉事件
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) closeDrawer();
  });

  // 暴露全域 API
  window.CartDrawer = {
    open: function () {
      refreshCart();
      openDrawer();
    },
    close: closeDrawer,
    refresh: refreshCart
  };

})();
